export const KEY_JWT = 'lfeudmnskqoepoalrfowuqnadgpfdssfdasmasjubfslava';

export const ACCESS_BY_LEVEL = {
    1: ['dashboard', 'users', 'categories', 'pending', 'resolved'],
    2: ['dashboard', 'pending', 'resolved'],
}